import { pathOr } from 'ramda';

import { AccountType } from 'src/enums/AccountType';
import { Organization, ShortOrganizationWithRate } from 'src/types/resources/Organization';
import { joinTruthy } from 'src/utils/string';
import revuudClientOpportunitiesLogo from 'src/assets/images/revuudClientOpportunitiesLogo.svg';

const OrganizationPresenter = {
  // id is null only for the masked "Revuud Client Opportunities" placeholder on a
  // Private Opportunity - a real organization with no uploaded logo still has a real id,
  // and should fall through to the Avatar's own initials fallback, not this logo
  avatarSrc: (organization: Pick<ShortOrganizationWithRate, 'id' | 'logo'>): string | null | undefined =>
    organization.id === null ? revuudClientOpportunitiesLogo : organization.logo,
  rate: (organization: Pick<Organization, 'rate' | 'tierRate'>) => {
    if (organization.rate) {
      return `${organization.rate}%`;
    }
    return `$${organization.tierRate}`;
  },
  address: (organization: Organization): string => {
    const { address1, address2, city, state, zipCode } = organization;
    const stateAndZipCode = `${state} ${zipCode}`;

    return joinTruthy([address1, address2, city, stateAndZipCode]);
  },
  valueByField: (organization: Organization, field: keyof Organization): string => {
    return pathOr('N/A', [field], organization);
  },
  isTrackedViaPendo: (organization: Organization | ShortOrganizationWithRate | null): boolean => {
    return organization && organization.accountType !== AccountType.test;
  },
  isTestOrganization: (accountType: Organization['accountType']) => accountType === AccountType.test,
};

export default OrganizationPresenter;
